import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_card.scss'

import { Props, DivAttributes } from '../utils/types'

const cx = bind(styles)

export namespace CardLevelNS {
  export const ten = '10'
  export const twenty = '20'
  export const thirty = '30'
  export const fourty = '40'
  export const fifty = '50'
}

export namespace CardVariantNS {
  export const hoverable = 'hoverable'
}

type CardLevel =
  | typeof CardLevelNS.ten
  | typeof CardLevelNS.twenty
  | typeof CardLevelNS.thirty
  | typeof CardLevelNS.fourty
  | typeof CardLevelNS.fifty

type CardVariant = typeof CardVariantNS.hoverable

export interface CardProps extends Props {
  level?: CardLevel
  variant?: CardVariant
}

const Card = React.forwardRef<HTMLDivElement, DivAttributes & CardProps>(
  (
    { variant, level = CardLevelNS.twenty, className, children, ...props },
    ref
  ) => (
    <div
      ref={ref}
      {...{
        className: cx(
          'core-card',
          {
            [`core-card--${variant}`]: variant,
            [`core-card--level-${level}`]: level,
          },
          className
        ),
        ...props,
      }}
    >
      {children}
    </div>
  )
)

Card.displayName = 'Card'

export default Card
